// extracted by mini-css-extract-plugin
export default {"blogPost":"BlogPost_blogPost__jcz5h"};